import { getFormFactor, useDeviceStore } from '@namespace/device';

export const useGetPlatformForFeed = () => {
  const { deviceFormFactor } = useDeviceStore();
  const formFactor = getFormFactor(deviceFormFactor);

  return formFactor;
};
